import * as i0 from "@angular/core";
import * as i1 from "../shared/popup/popup.component";
import * as i2 from "../modules/language/language.service";
var CopyToBufferService = /** @class */ (function () {
    function CopyToBufferService(popupComponent, languageService) {
        this.popupComponent = popupComponent;
        this.languageService = languageService;
    }
    CopyToBufferService.prototype.copyToBuffer = function (value, needMessage, messageText) {
        var tempInput = document.createElement('input');
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        if (needMessage) {
            var popupMessage = messageText ? messageText : this.languageService.getString('messagesData', 'codeCopied');
            this.popupComponent.showPopupSuccess({ text: popupMessage });
        }
    };
    CopyToBufferService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CopyToBufferService_Factory() { return new CopyToBufferService(i0.ɵɵinject(i1.PopupComponent), i0.ɵɵinject(i2.LanguageService)); }, token: CopyToBufferService, providedIn: "root" });
    return CopyToBufferService;
}());
export { CopyToBufferService };
